
// @ts-nocheck


export const localeCodes =  [
  "en",
  "lv",
  "lt",
  "et"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.js", load: () => import("../locales/en.js" /* webpackChunkName: "locale__builds_common_airbaltic_com_investors_locales_en_js" */), cache: true }],
  "lv": [{ key: "../locales/lv.js", load: () => import("../locales/lv.js" /* webpackChunkName: "locale__builds_common_airbaltic_com_investors_locales_lv_js" */), cache: true }],
  "lt": [{ key: "../locales/lt.js", load: () => import("../locales/lt.js" /* webpackChunkName: "locale__builds_common_airbaltic_com_investors_locales_lt_js" */), cache: true }],
  "et": [{ key: "../locales/et.js", load: () => import("../locales/et.js" /* webpackChunkName: "locale__builds_common_airbaltic_com_investors_locales_et_js" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "dir": "ltr",
      "label": "English",
      "title": "English",
      "key": "en",
      "language": "en-US",
      "files": [
        "/builds/common/airbaltic-com/investors/locales/en.js"
      ]
    },
    {
      "code": "lv",
      "dir": "ltr",
      "label": "Latviešu",
      "title": "Latviešu",
      "key": "lv",
      "language": "lv-LV",
      "files": [
        "/builds/common/airbaltic-com/investors/locales/lv.js"
      ]
    },
    {
      "code": "lt",
      "dir": "ltr",
      "label": "Lietuviškai",
      "title": "Lietuviškai",
      "key": "lt",
      "language": "lt-LT",
      "files": [
        "/builds/common/airbaltic-com/investors/locales/lt.js"
      ]
    },
    {
      "code": "et",
      "dir": "ltr",
      "label": "Eesti",
      "title": "Eesti",
      "key": "et",
      "language": "et-EE",
      "files": [
        "/builds/common/airbaltic-com/investors/locales/et.js"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "./locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://investors.airbaltic.com",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "dir": "ltr",
    "label": "English",
    "title": "English",
    "key": "en",
    "language": "en-US",
    "files": [
      {
        "path": "/builds/common/airbaltic-com/investors/locales/en.js"
      }
    ]
  },
  {
    "code": "lv",
    "dir": "ltr",
    "label": "Latviešu",
    "title": "Latviešu",
    "key": "lv",
    "language": "lv-LV",
    "files": [
      {
        "path": "/builds/common/airbaltic-com/investors/locales/lv.js"
      }
    ]
  },
  {
    "code": "lt",
    "dir": "ltr",
    "label": "Lietuviškai",
    "title": "Lietuviškai",
    "key": "lt",
    "language": "lt-LT",
    "files": [
      {
        "path": "/builds/common/airbaltic-com/investors/locales/lt.js"
      }
    ]
  },
  {
    "code": "et",
    "dir": "ltr",
    "label": "Eesti",
    "title": "Eesti",
    "key": "et",
    "language": "et-EE",
    "files": [
      {
        "path": "/builds/common/airbaltic-com/investors/locales/et.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
